import { IconProps } from "../../utils/global-types/global-types";

const RightArrowIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g clipPath="url(#clip0_4826_53131)">
      <path
        fill="currentColor"
        d="M14.808 8.534 10.475 4.2a.65.65 0 0 0-.465-.191.65.65 0 0 0-.464.191l-.394.394a.665.665 0 0 0 0 .934l2.528 2.534H3.648A.64.64 0 0 0 3 8.708v.556c0 .362.286.675.648.675h8.061l-2.557 2.547a.647.647 0 0 0 0 .922l.394.393a.65.65 0 0 0 .464.191c.176 0 .341-.068.465-.192l4.333-4.334A.65.65 0 0 0 15 9.001a.65.65 0 0 0-.192-.467"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4826_53131">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default RightArrowIcon;
